import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import "../styles/AssessmentForm.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TimePicker from 'react-time-picker';

const SUBMODALITIES_MAP = {
     USG: ["Sub1", "Sub2"],
     Mammography: ["Sub1", "Sub2"],
     BMD: ["Sub1", "Sub2"],
     CT: ["Sub1", "Sub2"],
     MRI: ["Sub1", "Sub2"],
};




export default function AssessmentForm({ initialData = null, onCancel, onSave }) {
     const submittingRef = useRef(false);
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [modalityAllowed, setModalityAllowed] = useState(null);
     const navigate = useNavigate();
     const [isSubmitting, setIsSubmitting] = useState(false);
     const [modalities, setModalities] = useState([]);


     const [selectedModality, setSelectedModality] = useState("");
     const [currentSelections, setCurrentSelections] = useState({});
     const [selectedRegions, setSelectedRegions] = useState({});
     const thStyle = {
          border: "1px solid #ccc",
          padding: "8px",
          backgroundColor: "#f2f2f2",
          textAlign: "left",
     };

     const tdStyle = {
          border: "1px solid #ccc",
          padding: "8px",
     };
     const [personal, setPersonal] = useState({
          positionApplied: "",
          candidateName: "",
          mobile: "",
          email: "",
          qualification: "",
          registration: "",
          paediatric: "",
          totalExperience: "",
          department: "",
          vdcLocation: "",
          typeOfAssociation: "",
          timingsFrom: "",
          timingsTo: "",
     });

     const calculateTotalBranches = () => {
          return Object.values(selectedRegions).reduce((total, branches) => total + branches.length, 0);
     };

     function onCancel() {
          navigate('/new-radiology-assessment'); // ✅ redirect to the route
     }

     const handleModalityChange = (modality, submodality, data) => {
          setCurrentSelections((prev) => ({
               ...prev,
               [submodality]: {
                    ...prev[submodality],
                    ...data,
               }
          }));
     };
     // final list
     function handleAdd() {
          if (!selectedModality) return;

          // Prevent adding duplicate modalities
          const alreadyExists = modalities.some(
               (entry) => entry.modality === selectedModality
          );
          if (alreadyExists) {
               alert(`${selectedModality} has already been added.`);
               return;
          }

          // Build entry for the selected modality
          const entry = {
               modality: selectedModality,
               selections: { ...currentSelections }, // shallow copy
          };

          // Add to modalities array
          setModalities((prev) => [...prev, entry]);

          // Reset selections
          setSelectedModality("");
          setCurrentSelections({});
     }



     const [current, setCurrent] = useState({
          modality: "",
          submodality: "",
          capability: "",
     });

     const [technical, setTechnical] = useState({
          CT: "",
          MRI: "",

          RadiographyReporting: "",
          USG: "",
          assessmentCT: "",
          assessmentMRI: "",
          assessmentRadiography: "",
          assessmentUSG: ""
     });

     const [hiring, setHiring] = useState({
          decision: "",
     });

     const [notes, setNotes] = useState({
          overallNotes: "",
     });

     const [personality, setPersonality] = useState({
          attitude: "",
          jobKnowledge: "",
          communication: "",
          confidence: "",
          personality: "",
          flexibility: "",
     });

     const [errors, setErrors] = useState({});

     useEffect(() => {
          if (initialData) {
               setPersonal((p) => ({
                    ...p,
                    positionApplied: initialData.positionApplied || initialData.appliedPosition || p.positionApplied,
                    candidateName: initialData.candidateName || initialData.name || p.candidateName,
                    mobile: initialData.mobile || initialData.phone || "99999 00000",
                    email: initialData.email || initialData.contactEmail || "candidate@example.com",
                    qualification: initialData.qualification || initialData.eduQualification || "MBBS, MD Radiology",
                    registration: initialData.registration || initialData.stateRegistration || "Yes",
                    paediatric: initialData.paediatric || initialData.paediatric || "Yes",
                    totalExperience: initialData.totalExperience || initialData.experienceYears || "6",
                    department: initialData.department || initialData.dept || "Radiology",
                    vdcLocation: initialData.vdcLocation || initialData.location || "Mumbai",
                    typeOfAssociation: initialData.typeOfAssociation || initialData.associationType || "Full Time",
                    timingsFrom: initialData.timingsFrom || initialData.shiftStart || "09:00",
                    timingsTo: initialData.timingsTo || initialData.shiftEnd || "17:00",
               }));

               if (initialData.modalities && Array.isArray(initialData.modalities)) {
                    setModalities(initialData.modalities);
               }

               setTechnical((t) => ({
                    ...t,
                    RadiographyReporting: initialData.technicalRadiographyReporting || t.RadiographyReporting,
                    CT: initialData.technicalCT || t.CT,
                    MRI: initialData.technicalMRI || t.MRI,
                    USG: initialData.technocalUSG || t.USG,
                    // specialProcedures: initialData.specialProcedures || t.specialProcedures,
               }));

               setHiring((h) => ({
                    ...h,
                    decision: initialData.status || initialData.decision || "Onhold",
               }));

               setNotes((n) => ({
                    ...n,
                    overallNotes: initialData.remarks || initialData.overallNotes || "",
               }));

               setPersonality((p) => ({
                    ...p,
                    attitude: initialData.attitude || p.attitude,
                    jobKnowledge: initialData.jobKnowledge || p.jobKnowledge,
                    communication: initialData.communication || p.communication,
                    confidence: initialData.confidence || p.confidence,
                    personality: initialData.personality || p.personality,
                    flexibility: initialData.flexibility || p.flexibility,
               }));
          }
     }, [initialData]);

     function handlePersonalChange(e) {
          const { name, value } = e.target;
          setPersonal((p) => ({ ...p, [name]: value }));
     }

     function handleCurrentChange(field, value) {
          setCurrent((c) => ({ ...c, [field]: value, ...(field === "modality" ? { submodality: "", capability: "" } : {}) }));
     }

     function addModalityEntry() {
          if (current.modality && current.submodality && current.capability) {
               setModalities([...modalities, current]);
               setCurrent({ modality: "", submodality: "", capability: "" }); // reset
          }
     }

     function handleTechnicalChange(e) {
          const { name, value } = e.target;
          setTechnical((t) => ({ ...t, [name]: value }));
     }

     function handleHiringChange(e) {
          const { name, value } = e.target;
          setHiring((h) => ({ ...h, [name]: value }));
     }

     function handleNotesChange(e) {
          const { name, value } = e.target;
          setNotes((n) => ({ ...n, [name]: value }));
     }

     function handlePersonalityChange(e) {
          const { name, value } = e.target;
          setPersonality((p) => ({ ...p, [name]: value }));
     }

     //  function validateAll() {
     //   const newErrors = {};

     //   // Safely validate personal
     //   if (personal && typeof personal === "object") {
     //     Object.entries(personal).forEach(([k, v]) => {
     //       if (!v || v.toString().trim() === "") {
     //         newErrors[`personal.${k}`] = "Required";
     //       }
     //     });

     //     // Email format check
     //     if (personal.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personal.email)) {
     //       newErrors["personal.email"] = "Invalid email format";
     //     }

     //     // Mobile format check
     //     if (personal.mobile && !/^\d{10,15}$/.test(personal.mobile.replace(/\s+/g, ""))) {
     //       newErrors["personal.mobile"] = "Invalid mobile number";
     //     }
     //   }

     //   // Validate modalities
     //   if (!Array.isArray(modalities) || modalities.length === 0) {
     //     newErrors["modalities"] = "At least one modality is required";
     //   }

     //   // Validate technical
     //   if (technical && typeof technical === "object") {
     //     Object.entries(technical).forEach(([k, v]) => {
     //       if (!v || v.toString().trim() === "") {
     //         newErrors[`technical.${k}`] = "Required";
     //       }
     //     });
     //   }

     //   // Validate personality
     //   if (personality && typeof personality === "object") {
     //     Object.entries(personality).forEach(([k, v]) => {
     //       if (!v || v.toString().trim() === "") {
     //         newErrors[`personality.${k}`] = "Required";
     //       }
     //     });
     //   }



     //   // ✅ Validate selected regions
     //   const totalSelectedBranches = Object.values(selectedRegions || {}).reduce(
     //     (acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0),
     //     0
     //   );
     //   if (totalSelectedBranches === 0) {
     //     newErrors["regions"] = "At least one region branch must be selected";
     //   }

     //   // Set errors to state
     //   setErrors(newErrors);

     //   // Return both for external use (like handleSubmit)
     //   return {
     //     isValid: Object.keys(newErrors).length === 0,
     //     newErrors,
     //   };
     // }



     async function handleSubmit(e) {

          e.preventDefault();
          if (isSubmitting) {
               return; // Prevent multiple submissions
          }
          if (submittingRef.current) return;

          submittingRef.current = true; // lock submission immediately
          setIsSubmitting(true);        // disable button visually



          // const { isValid, newErrors } = validateAll();

          // if (!isValid) {
          //   const errorText = Object.entries(newErrors)
          //     .map(([field, message]) => `• ${field}: ${message}`)
          //     .join("\n");

          //  // alert("Please fix the following errors:\n\n" + errorText);

          //   window.scrollTo({ top: 0, behavior: "smooth" });
          //   return;
          // }

          const payload = {
               personal,
               modalities,

               hiring,
               notes,
               regions: selectedRegions,

               technical: [
                    {
                         type: "Radiography Reporting",
                         assessment: technical.assessmentRadiography || "",
                         notes: technical.RadiographyReporting || "",
                         grading: technical.RadiographyGrading || ""
                    },
                    {
                         type: "CT Scans Reporting",
                         assessment: technical.assessmentCT || "",
                         notes: technical.CT || "",
                         grading: technical.CTGrading || ""
                    },
                    {
                         type: "MRI Scans Reporting",
                         assessment: technical.assessmentMRI || "",
                         notes: technical.MRI || "",
                         grading: technical.MRIGrading || ""
                    },
                    {
                         type: "USG Scanning",
                         assessment: technical.assessmentUSG || "",
                         notes: technical.USG || "",
                         grading: technical.USGGrading || ""
                    }
               ],

               personality: [
                    {
                         type: "Attitude",
                         criteria: personality.attitude || ""
                         // notes: technical.RadiographyReporting || ""
                    },
                    {
                         type: "Job Knowledge",
                         criteria: personality.jobKnowledge || ""
                         // notes: technical.CT || ""
                    },
                    {
                         type: "Communication Skills",
                         criteria: personality.communication || ""
                         // notes: technical.MRI || ""
                    },
                    {
                         type: "Confidence",
                         criteria: personality.confidence || ""
                         // notes: technical.USG || ""
                    },
                    {
                         type: "Personality",
                         criteria: personality.personality || ""
                         // notes: technical.USG || ""
                    },
                    {
                         type: "Flexibility",
                         criteria: personality.flexibility || ""
                         // notes: technical.USG || ""
                    }
               ]
          };


          setIsSubmitting(true);
          try {
               const response = await fetch(`${baseUrl}/assessment_form`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${sessionStorage.getItem("token")}`, },
                    body: JSON.stringify(payload),
               });

               if (!response.ok) {
                    const error = await response.json();
                    console.error("API error:", error);
                    alert("Submission failed.");
                    return;
               }

               const result = await response.json();
               navigate("/new-radiology-assessment", {
                    state: { successMessage: "Assessment successfully added!" },
               });

          } catch (err) {
               console.error("Submit failed:", err);
               alert("Network or server error.");
          } finally {
               submittingRef.current = false;
               setIsSubmitting(false);
          }
     }

     const personalityOptions = [
          "Outstanding",
          "Exceeds Expectation",
          "Meets Expectation",
          "Does not meet expectation",
     ];

     const cardStyle = {
          background: "#fff",
          padding: "5px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgb(0 0 0 / 0.1)",
          marginBottom: "5px",
     };

     const grid3Columns = {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
          alignItems: "start",
     };

     const grid4Columns = {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "5px",
          alignItems: "start",
     };

     const grid6Columns = {
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "16px",
          alignItems: "start",
     };


     const MODALITY_MAP = {
          XRAY: [
               "Plain Radiography - Basic",
               "Plain Radiography - Advanced",
               "Lower limb scanogram",
               "C-Spine",
               "D-Spine",
               "L-Spine",
               "Whole-Spine",
               "Boneage"
          ],
          XRAYProcedure: [
               "Barium Study",
               "Distal Loopogram/ Fistulogram",
               "HSG",
               "IVP",
               "MCUG",
               "RGU"
          ],
          Mammography: [
               "Mammography",
               "Mammography with out screening"
          ],
          BMD: [
               "Mammography"
          ],
          USG: [
               "Basic",
               "Doppler Studies",
               "Thyroid",
               "Scrotum USG",
               "Breast USG",
               "TIFFA",
               "Foetal Echo",
               "MSK USG",
               "Penile Doppler",
               "TRUS",
               "USG Guided FNAC",
               "USG Guided Trucut biopsy",
               "USG Guided aspiration",
               "Breast Biopsy",
               "TRUS guided Biopsy"
          ],
          CT: [
               "Brain",
               "PNS",
               "Orbits",
               "Temporal Bone",
               "Neck",
               "KUB",
               "Spine",
               "Chest",
               "Abdomen",
               "DECT",
               "3D CT",
               "CT Angiography",
               "Coronary CT",
               // "Virtual Bronchoscopy",
               "CT Perfusion",
               "CT Screening",
               // "Bronchoscopy / Colonoscopy",
               "CT Guided Biopsy",
               "Virtual Bronchoscopy / Colonoscopy"
          ],
          MRI: [
               "Brain",
               "Spine",
               "Ankle",
               "Elbow",
               "Hip",
               "Knee",
               "Wrist",
               "Foot",
               "Shoulder",
               "SI Joint",
               "MSK -Small Joints",
               "MRI Extremities",
               // "Boss Protocol - PNS",
               "DBS Protocol",
               "Dementia Protocol",
               "Epilepsy Protocol",
               "Headache Protocol",
               "BIH/lIH Protocol",
               "MRI Cochlear Implant Protocol",
               "Stroke Protocol",
               "Vertigo Protocol",
               "Visual Pathway Protocol",
               "Abdomen",
               "Brain with CSF",
               "Cardiac MRI",
               "Chest",
               "Dynamic Sleep Study",
               "Fibroid Mapping",
               "FMR + DTI + MRS",
               "FMRI",
               "Foetal MRI",
               "Lymphangiography",
               "Movement Disorder",
               "MRCP",
               "MRI Angiography",
               "MRI Arthogram",
               "MRI Breast",
               "MRI Cartigram",
               "MRI Cisternography",
               "MRI Defaecography",
               "MRI Enterography / MRI Enteroclysis",
               "MRI Face",
               "MRI Fistulogram",
               "MRI Liver",
               "MRI Neurography",
               "MRI Perfusion",
               "MRI Peripheral Angiography",
               "MRI Screening",
               "MRI TM Joints",
               "MRI Tractography",
               "MRI Urography",
               // "MSK",
               "Neck",
               "Pelvis",
               "PNS",
               "Prostate",
               "Sella/Pituitary",
               "Soft Tissue MRI",
               "Spectroscopy",
               "Temporal Bone",
               "Vessel Wall",
               // "OverallEvaluation Notes",
               "Whole Body"
          ],
          "Special Procedures": [
               "RGU",
               "MCUG",
               "Barium Swallow",
               "Barium Enema",
               "HSG",
          ],
     };


     const handleBranchToggle = (region, branch) => {
          setSelectedRegions(prev => {
               const current = prev[region] || [];
               const updated = current.includes(branch)
                    ? current.filter(b => b !== branch) // remove
                    : [...current, branch];             // add
               return { ...prev, [region]: updated };
          });
     };

     const handleSelectAll = (region, branches) => {
          setSelectedRegions((prev) => {
               const allSelected = branches.every((b) => (prev[region] || []).includes(b));
               return {
                    ...prev,
                    [region]: allSelected ? [] : branches,
               };
          });
     };

     const handleDelete = (index) => {
          setModalities((prevModalities) => prevModalities.filter((_, i) => i !== index));
     };


     return (
          <form onSubmit={handleSubmit}>
               <div
                    style={{
                         minHeight: "100vh",
                         padding: 5,
                         overflowY: "auto",
                         backgroundColor: "#f9f9f9",
                         boxSizing: "border-box",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "flex-start",

                    }}
               >
                    <div
                         style={{
                              width: "100%",
                              maxWidth: "100%",
                              boxSizing: "border-box",

                         }}
                    >
                         <div className="form-section" style={cardStyle}>
                              <div className="section-title" style={{ marginBottom: "5px" }}>
                                   Personal Details
                              </div>

                              <div style={grid4Columns}>
                                   <label>
                                        Position Applied
                                        <input
                                             className="form-control input-form"
                                             name="positionApplied"
                                             value={personal.positionApplied}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.positionApplied"] && (
                                             <div className="field-error">{errors["personal.positionApplied"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Candidate Name
                                        <input
                                             className="form-control input-form"
                                             name="candidateName"
                                             value={personal.candidateName}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.candidateName"] && (
                                             <div className="field-error">{errors["personal.candidateName"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Mobile
                                        <input
                                             className="form-control input-form"
                                             name="mobile"
                                             type="text"
                                             value={personal.mobile}
                                             maxLength={10} // optional
                                             required
                                             onChange={(e) => {
                                                  // Filter only digits from the input value
                                                  const onlyNums = e.target.value.replace(/\D/g, "");
                                                  // Call your handler with a synthetic event-like object
                                                  handlePersonalChange({
                                                       target: {
                                                            name: e.target.name,
                                                            value: onlyNums,
                                                       },
                                                  });
                                             }}
                                        />
                                        {errors["personal.mobile"] && (
                                             <div className="field-error">{errors["personal.mobile"]}</div>
                                        )}
                                   </label>



                                   <label>
                                        Email
                                        <input
                                             className="form-control input-form"
                                             name="email"
                                             type="email"  // <-- Add this
                                             value={personal.email}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.email"] && (
                                             <div className="field-error">{errors["personal.email"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Educational Qualification
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="qualification"
                                             value={personal.qualification}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.qualification"] && (
                                             <div className="field-error">{errors["personal.qualification"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Department
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="department"
                                             value={personal.department}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.department"] && (
                                             <div className="field-error">{errors["personal.department"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Relevant State Medical Registration
                                        <select
                                             className="form-control input-form"
                                             required
                                             name="registration"
                                             value={personal.registration}
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option>Yes</option>
                                             <option>No</option>
                                        </select>
                                        {errors["personal.registration"] && (
                                             <div className="field-error">{errors["personal.registration"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Paediatric
                                        <select
                                             className="form-control input-form"
                                             required
                                             name="paediatric"
                                             value={personal.paediatric}
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option>Yes</option>
                                             <option>No</option>
                                        </select>
                                        {errors["personal.paediatric"] && (
                                             <div className="field-error">{errors["personal.paediatric"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Total Experience (In Yrs.)
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="totalExperience"
                                             value={personal.totalExperience}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.totalExperience"] && (
                                             <div className="field-error">{errors["personal.totalExperience"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        VDC Location (Applied for)
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="vdcLocation"
                                             value={personal.vdcLocation}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.vdcLocation"] && (
                                             <div className="field-error">{errors["personal.vdcLocation"]}</div>
                                        )}
                                   </label>




                                   <label>
                                        Timings From
                                        <input
                                             required
                                             type="time"
                                             className="form-control input-form"
                                             name="timingsFrom"
                                             min="07:00"
                                             max="23:00"
                                             value={personal.timingsFrom}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.timingsFrom"] && (
                                             <div className="field-error">{errors["personal.timingsFrom"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Timings To
                                        <input
                                             required
                                             type="time"
                                             min="07:00"
                                             max="23:00"
                                             className="form-control input-form"
                                             name="timingsTo"
                                             value={personal.timingsTo}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.timingsTo"] && (
                                             <div className="field-error">{errors["personal.timingsTo"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Type of Association
                                        <select
                                             className="form-control input-form"
                                             name="typeOfAssociation"
                                             value={personal.typeOfAssociation}
                                             required
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option value="Full Time">Full Time</option>
                                             <option value="Part Time">Part Time</option>
                                             <option value="Target Model">Target Model</option>
                                             <option value="Base">Base</option>
                                        </select>

                                        {errors["personal.typeOfAssociation"] && (
                                             <div className="field-error">{errors["personal.typeOfAssociation"]}</div>
                                        )}
                                   </label>
                              </div>
                         </div>



                         <div className="form-section" style={{ marginBottom: "24px" }}>
                              <div className="section-title" style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
                                   Assessment of Relevant Modalities
                              </div>

                              {/* Modality Dropdown */}
                              <label style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                                   <span style={{ fontWeight: "500", marginRight: "8px" }}>Modality:</span>
                                   <select
                                        className="form-control input-form"
                                        value={selectedModality}
                                        onChange={(e) => {
                                             setSelectedModality(e.target.value);
                                             setCurrentSelections({});
                                        }}
                                        style={{
                                             height: "36px",
                                             width: "300px",
                                             padding: "4px 12px",
                                             borderRadius: "6px",
                                             border: "1px solid #ccc",
                                             fontSize: "14px"
                                        }}
                                   >
                                        <option value="">-- Select Modality --</option>
                                        {Object.keys(MODALITY_MAP).map((modality) => (

                                             <option key={modality} value={modality}>
                                                  {modality}
                                             </option>
                                        ))}
                                   </select>
                              </label>

                              {errors["modality"] && (
                                   <div className="field-error" style={{ color: "red", fontSize: "13px", marginTop: "-8px", marginBottom: "8px" }}>
                                        {errors["modality"]}
                                   </div>
                              )}

                              {selectedModality && (
                                   <div className="submodality-table" style={{ marginTop: "8px" }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "16px" }}>
                                             <thead style={{ backgroundColor: "#f8f9fa" }}>
                                                  <tr >
                                                       {["Modality", "Items", "Applicable", "Intermediate", "Expert"].map((heading) => (
                                                            <th
                                                                 key={heading}
                                                                 style={{
                                                                      padding: "12px",
                                                                      textAlign: "center",
                                                                      fontSize: "14px",
                                                                      fontWeight: 600,
                                                                      borderBottom: "1px solid #dee2e6",
                                                                      verticalAlign: "middle",

                                                                 }}
                                                            >
                                                                 {heading}
                                                            </th>
                                                       ))}
                                                  </tr>
                                             </thead>
                                             <tbody>
                                                  {Array.isArray(MODALITY_MAP[selectedModality]) &&
                                                       MODALITY_MAP[selectedModality]
                                                            .filter((sub) => sub !== "MSK") // ✅ Hide MSK     
                                                            .map((sub, idx) => {
                                                                 const isApplicable = currentSelections[sub]?.applicable === "YES";
                                                                 const selectedLevel = currentSelections[sub]?.level;

                                                                 return (
                                                                      <tr key={sub} style={{ lineHeight: "0px" }}>
                                                                           {/* Merge cell for Modality name */}
                                                                           {idx === 0 && (
                                                                                <td
                                                                                     rowSpan={MODALITY_MAP[selectedModality].length}
                                                                                     style={{
                                                                                          padding: "12px",
                                                                                          fontWeight: "500",
                                                                                          borderBottom: "1px solid #dee2e6",
                                                                                          backgroundColor: "#fdfdfd",
                                                                                          textAlign: "center",
                                                                                          verticalAlign: "middle"
                                                                                     }}
                                                                                >
                                                                                     {selectedModality}
                                                                                </td>
                                                                           )}

                                                                           {/* Submodality name */}
                                                                           <td
                                                                                style={{
                                                                                     padding: "12px",
                                                                                     borderBottom: "1px solid #dee2e6",
                                                                                     verticalAlign: "middle"
                                                                                }}
                                                                           >
                                                                                {sub}
                                                                           </td>

                                                                           {/* Applicable Yes/No */}
                                                                           <td
                                                                                style={{
                                                                                     padding: "12px",
                                                                                     borderBottom: "1px solid #dee2e6",
                                                                                     textAlign: "center",
                                                                                     verticalAlign: "middle"
                                                                                }}
                                                                           >
                                                                                <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
                                                                                     <label style={{ display: "flex", alignItems: "center", gap: "6px", paddingTop: "5px" }}>

                                                                                          Yes
                                                                                     </label>
                                                                                     <input
                                                                                          type="radio"
                                                                                          name={`applicable-${selectedModality}-${sub}`}
                                                                                          value="YES"
                                                                                          onChange={() =>
                                                                                               handleModalityChange(selectedModality, sub, {
                                                                                                    applicable: "YES",
                                                                                                    level: ""
                                                                                               })
                                                                                          }
                                                                                          checked={currentSelections[sub]?.applicable === "YES"}
                                                                                     />
                                                                                     <label style={{ display: "flex", alignItems: "center", gap: "6px", paddingTop: "5px" }}>

                                                                                          No
                                                                                     </label>
                                                                                     <input
                                                                                          type="radio"
                                                                                          name={`applicable-${selectedModality}-${sub}`}
                                                                                          value="NO"
                                                                                          onChange={() =>
                                                                                               handleModalityChange(selectedModality, sub, {
                                                                                                    applicable: "NO",
                                                                                                    level: ""
                                                                                               })
                                                                                          }
                                                                                          checked={currentSelections[sub]?.applicable === "NO"}
                                                                                     />
                                                                                </div>
                                                                           </td>

                                                                           {/* Skill Level Options */}
                                                                           {["Intermediate", "Expert"].map((level) => (
                                                                                <td
                                                                                     key={level}
                                                                                     style={{
                                                                                          padding: "12px",
                                                                                          borderBottom: "1px solid #dee2e6",
                                                                                          textAlign: "center",
                                                                                          verticalAlign: "middle",
                                                                                          opacity: isApplicable ? 1 : 0.4,
                                                                                          pointerEvents: isApplicable ? "auto" : "none"
                                                                                     }}
                                                                                >
                                                                                     <input
                                                                                          type="radio"
                                                                                          name={`level-${selectedModality}-${sub}`}
                                                                                          value={level}
                                                                                          onChange={() =>
                                                                                               handleModalityChange(selectedModality, sub, {
                                                                                                    applicable: currentSelections[sub]?.applicable || "YES", // ✅ Fixed line
                                                                                                    level
                                                                                               })
                                                                                          }
                                                                                          checked={selectedLevel === level}
                                                                                          disabled={!isApplicable}
                                                                                     />
                                                                                </td>
                                                                           ))}
                                                                      </tr>
                                                                 );
                                                            })}
                                             </tbody>
                                        </table>

                                        {/* + Add button */}
                                        <button
                                             type="button"
                                             onClick={handleAdd}
                                             disabled={Object.keys(currentSelections).length === 0}
                                             style={{
                                                  padding: "8px 16px",
                                                  backgroundColor: "#007bff",
                                                  color: "#fff",
                                                  border: "none",
                                                  borderRadius: "4px",
                                                  fontWeight: "500",
                                                  fontSize: "14px",
                                                  cursor: Object.keys(currentSelections).length === 0 ? "not-allowed" : "pointer",
                                                  opacity: Object.keys(currentSelections).length === 0 ? 0.6 : 1
                                             }}
                                        >
                                             + Add
                                        </button>
                                   </div>
                              )}


                              {/* Display added modalities */}
                              <div style={{ marginTop: "24px" }}>
                                   <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "12px" }}>Added Modalities</h6>
                                   {!Array.isArray(modalities) || modalities.length === 0 ? (
                                        <p style={{ color: "#6c757d" }}>No modalities added yet.</p>
                                   ) : (
                                        modalities.map((entry, idx) => (
                                             <div
                                                  key={idx}
                                                  style={{
                                                       marginBottom: "16px",
                                                       padding: "12px",
                                                       border: "1px solid #dee2e6",
                                                       borderRadius: "6px",
                                                       backgroundColor: "#f8f9fa",
                                                       display: "flex",
                                                       justifyContent: "space-between",
                                                       alignItems: "flex-start"
                                                  }}
                                             >
                                                  <div>
                                                       <strong style={{ fontSize: "15px" }}>{entry.modality}</strong>
                                                       <ul style={{ paddingLeft: "18px", marginTop: "6px", marginBottom: 0 }}>
                                                            {Object.entries(entry.selections).map(([submodality, data]) => (
                                                                 <li key={submodality}>
                                                                      {submodality}: {data?.applicable === "YES" ? data.level : "Not Applicable"}
                                                                 </li>
                                                            ))}
                                                       </ul>
                                                  </div>
                                                  <button
                                                       onClick={() => handleDelete(idx)}
                                                       style={{
                                                            backgroundColor: "#dc3545",
                                                            color: "#fff",
                                                            border: "none",
                                                            borderRadius: "4px",
                                                            padding: "6px 10px",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            cursor: "pointer",
                                                            height: "fit-content"
                                                       }}
                                                       aria-label={`Delete ${entry.modality}`}
                                                  >
                                                       Delete
                                                  </button>
                                             </div>
                                        ))
                                   )}
                              </div>
                         </div>


                         {/* <br/> */}


                         <div
                              style={{
                                   display: "grid",
                                   gridTemplateColumns: "1fr 1fr",
                                   gap: 39,
                                   marginBottom: 5,
                                   flexWrap: "wrap",
                              }}
                         >
                              {/* Left Side - Technical Evaluation */}
                              <div style={{ minWidth: 0 }}>
                                   <div className="form-section" style={cardStyle}>
                                        <div className="section-title" style={{ marginBottom: "16px" }}>Technical Evaluation</div>

                                        <div
                                             style={{
                                                  overflowX: "auto",
                                                  width: "100%",
                                                  paddingBottom: "8px"
                                             }}
                                        >
                                             <div
                                                  style={{
                                                       display: "grid",
                                                       gridTemplateColumns: "1fr minmax(0, auto) 200px 1fr",
                                                       columnGap: 16,
                                                       rowGap: 12,
                                                       alignItems: "center",
                                                       minWidth: "600px"
                                                  }}
                                             >
                                                  {/* Header row */}
                                                  <div><strong>Type</strong></div>
                                                  <div><strong>Grade (0-10)</strong></div>
                                                  <div><strong>Assessment</strong></div>
                                                  <div><strong>Notes</strong></div>

                                                  {/* Radiography Reporting */}
                                                  <div style={{
                                                       padding: "8px 12px",
                                                       backgroundColor: "#f8f9fa",
                                                       borderRadius: "6px",
                                                       border: "1px solid #e9ecef"
                                                  }}>
                                                       Radiography Reporting
                                                  </div>
                                                  <div style={{ overflowX: "auto" }}>
                                                       <div style={{
                                                            display: "flex",
                                                            gap: 6,
                                                            width: "max-content",
                                                            padding: "8px",
                                                            backgroundColor: "#f8f9fa",
                                                            borderRadius: "6px",
                                                            border: "1px solid #e9ecef"
                                                       }}>
                                                            {[...Array(11).keys()].map(num => (
                                                                 <label key={`gradeRadiography-${num}`} style={{
                                                                      display: "flex",
                                                                      flexDirection: "column",
                                                                      alignItems: "center",
                                                                      padding: "4px 2px"
                                                                 }}>
                                                                      <input
                                                                           type="radio"
                                                                           name="gradeRadiography"
                                                                           value={num}
                                                                           checked={technical.gradeRadiography === String(num) || technical.gradeRadiography === num}
                                                                           onChange={handleTechnicalChange}
                                                                           style={{ cursor: "pointer" }}
                                                                      />
                                                                      <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{num}</span>
                                                                 </label>
                                                            ))}
                                                       </div>
                                                       <div style={{
                                                            fontSize: "0.75rem",
                                                            color: "#6c757d",
                                                            marginTop: "4px",
                                                            textAlign: "center"
                                                       }}>
                                                            Selected: {technical.gradeRadiography || "None"}
                                                       </div>
                                                  </div>
                                                  <div>
                                                       <select
                                                            className="form-control input-form"
                                                            required
                                                            name="assessmentRadiography"
                                                            value={technical.assessmentRadiography || ""}
                                                            onChange={handleTechnicalChange}
                                                            style={{
                                                                 height: "32px",
                                                                 width: "100%",
                                                                 padding: "0 12px",
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px"
                                                            }}
                                                       >
                                                            <option value="">-- Select --</option>
                                                            <option value="Good">Good</option>
                                                            <option value="Satisfactory">Satisfactory</option>
                                                            <option value="Dissatisfactory">Dissatisfactory</option>
                                                            <option value="NotApplicable">Not Applicable</option>
                                                       </select>
                                                       <div className="field-error">{errors["technical.assessmentRadiography"]}</div>
                                                  </div>
                                                  <div>
                                                       <input
                                                            className="form-control input-form"
                                                            name="RadiographyReporting"
                                                            value={technical.RadiographyReporting || ""}
                                                            onChange={handleTechnicalChange}
                                                            required
                                                            style={{
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px",
                                                                 padding: "6px 12px"
                                                            }}
                                                       />
                                                       <div className="field-error">{errors["technical.RadiographyReporting"]}</div>
                                                  </div>

                                                  {/* CT Scans Reporting */}
                                                  <div style={{
                                                       padding: "8px 12px",
                                                       backgroundColor: "#f8f9fa",
                                                       borderRadius: "6px",
                                                       border: "1px solid #e9ecef"
                                                  }}>
                                                       CT Scans Reporting
                                                  </div>
                                                  <div style={{ overflowX: "auto" }}>
                                                       <div style={{
                                                            display: "flex",
                                                            gap: 6,
                                                            width: "max-content",
                                                            padding: "8px",
                                                            backgroundColor: "#f8f9fa",
                                                            borderRadius: "6px",
                                                            border: "1px solid #e9ecef"
                                                       }}>
                                                            {[...Array(11).keys()].map(num => (
                                                                 <label key={`gradeCT-${num}`} style={{
                                                                      display: "flex",
                                                                      flexDirection: "column",
                                                                      alignItems: "center",
                                                                      padding: "4px 2px"
                                                                 }}>
                                                                      <input
                                                                           type="radio"
                                                                           name="gradeCT"
                                                                           value={num}
                                                                           checked={technical.gradeCT === String(num) || technical.gradeCT === num}
                                                                           onChange={handleTechnicalChange}
                                                                           style={{ cursor: "pointer" }}
                                                                      />
                                                                      <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{num}</span>
                                                                 </label>
                                                            ))}
                                                       </div>
                                                       <div style={{
                                                            fontSize: "0.75rem",
                                                            color: "#6c757d",
                                                            marginTop: "4px",
                                                            textAlign: "center"
                                                       }}>
                                                            Selected: {technical.gradeCT || "None"}
                                                       </div>
                                                  </div>
                                                  <div>
                                                       <select
                                                            className="form-control input-form"
                                                            required
                                                            name="assessmentCT"
                                                            value={technical.assessmentCT || ""}
                                                            onChange={handleTechnicalChange}
                                                            style={{
                                                                 height: "32px",
                                                                 width: "100%",
                                                                 padding: "0 12px",
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px"
                                                            }}
                                                       >
                                                            <option value="">-- Select --</option>
                                                            <option value="Good">Good</option>
                                                            <option value="Satisfactory">Satisfactory</option>
                                                            <option value="Dissatisfactory">Dissatisfactory</option>
                                                            <option value="NotApplicable">Not Applicable</option>
                                                       </select>
                                                       <div className="field-error">{errors["technical.assessmentCT"]}</div>
                                                  </div>
                                                  <div>
                                                       <input
                                                            className="form-control input-form"
                                                            required
                                                            name="CT"
                                                            value={technical.CT || ""}
                                                            onChange={handleTechnicalChange}
                                                            style={{
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px",
                                                                 padding: "6px 12px"
                                                            }}
                                                       />
                                                       <div className="field-error">{errors["technical.CT"]}</div>
                                                  </div>

                                                  {/* MRI Scans Reporting */}
                                                  <div style={{
                                                       padding: "8px 12px",
                                                       backgroundColor: "#f8f9fa",
                                                       borderRadius: "6px",
                                                       border: "1px solid #e9ecef"
                                                  }}>
                                                       MRI Scans Reporting
                                                  </div>
                                                  <div style={{ overflowX: "auto" }}>
                                                       <div style={{
                                                            display: "flex",
                                                            gap: 6,
                                                            width: "max-content",
                                                            padding: "8px",
                                                            backgroundColor: "#f8f9fa",
                                                            borderRadius: "6px",
                                                            border: "1px solid #e9ecef"
                                                       }}>
                                                            {[...Array(11).keys()].map(num => (
                                                                 <label key={`gradeMRI-${num}`} style={{
                                                                      display: "flex",
                                                                      flexDirection: "column",
                                                                      alignItems: "center",
                                                                      padding: "4px 2px"
                                                                 }}>
                                                                      <input
                                                                           type="radio"
                                                                           name="gradeMRI"
                                                                           value={num}
                                                                           checked={technical.gradeMRI === String(num) || technical.gradeMRI === num}
                                                                           onChange={handleTechnicalChange}
                                                                           style={{ cursor: "pointer" }}
                                                                      />
                                                                      <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{num}</span>
                                                                 </label>
                                                            ))}
                                                       </div>
                                                       <div style={{
                                                            fontSize: "0.75rem",
                                                            color: "#6c757d",
                                                            marginTop: "4px",
                                                            textAlign: "center"
                                                       }}>
                                                            Selected: {technical.gradeMRI || "None"}
                                                       </div>
                                                  </div>
                                                  <div>
                                                       <select
                                                            className="form-control input-form"
                                                            required
                                                            name="assessmentMRI"
                                                            value={technical.assessmentMRI || ""}
                                                            onChange={handleTechnicalChange}
                                                            style={{
                                                                 height: "32px",
                                                                 width: "100%",
                                                                 padding: "0 12px",
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px"
                                                            }}
                                                       >
                                                            <option value="">-- Select --</option>
                                                            <option value="Good">Good</option>
                                                            <option value="Satisfactory">Satisfactory</option>
                                                            <option value="Dissatisfactory">Dissatisfactory</option>
                                                            <option value="NotApplicable">Not Applicable</option>
                                                       </select>
                                                       <div className="field-error">{errors["technical.assessmentMRI"]}</div>
                                                  </div>
                                                  <div>
                                                       <input
                                                            className="form-control input-form"
                                                            required
                                                            name="MRI"
                                                            value={technical.MRI || ""}
                                                            onChange={handleTechnicalChange}
                                                            style={{
                                                                 border: "1px solid #ced4da",
                                                                 borderRadius: "4px",
                                                                 padding: "6px 12px"
                                                            }}
                                                       />
                                                       <div className="field-error">{errors["technical.MRI"]}</div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>

                              {/* Right Side - Regions */}
                              <div style={{ minWidth: 0 }}>
                                   <div className="accordion-section">
                                        <div className="accordion-content">
                                             <div className="section-title" style={{ marginBottom: "16px" }}>
                                                  Regions
                                                  <span style={{
                                                       fontSize: "0.875rem",
                                                       fontWeight: "normal",
                                                       color: "#6c757d",
                                                       marginLeft: "8px"
                                                  }}>
                                                       Total Selected: {calculateTotalBranches()} branches
                                                  </span>
                                             </div>
                                             <div className="branch-access-container">
                                                  <p className="branch-access-description" style={{
                                                       marginBottom: "16px",
                                                       color: "#6c757d",
                                                       fontSize: "0.875rem"
                                                  }}>
                                                       Select the regions and branches where access should be granted:
                                                  </p>

                                                  {errors["regions"] && (
                                                       <div className="field-error" style={{ marginTop: "8px", marginBottom: "16px" }}>
                                                            {errors["regions"]}
                                                       </div>
                                                  )}

                                                  <div
                                                       className="branch-access-grid"
                                                       style={{
                                                            display: "flex",
                                                            gap: "16px",
                                                            overflowX: "auto",
                                                            paddingBottom: "12px",
                                                            whiteSpace: "nowrap",
                                                       }}
                                                  >
                                                       {/* AP & Telangana */}
                                                       <div className="region-card" style={{
                                                            flex: "0 0 auto",
                                                            minWidth: "280px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            padding: "16px",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                       }}>
                                                            <div className="region-card-header" style={{
                                                                 marginBottom: "12px",
                                                                 paddingBottom: "12px",
                                                                 borderBottom: "2px solid #e9ecef"
                                                            }}>
                                                                 <label className="region-select-all" style={{
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      gap: "8px",
                                                                      cursor: "pointer",
                                                                      fontWeight: "bold",
                                                                      fontSize: "1rem"
                                                                 }}>
                                                                      <input
                                                                           type="checkbox"
                                                                           checked={(selectedRegions["AP & Telangana"] || []).length === 13}
                                                                           onChange={() =>
                                                                                handleSelectAll("AP & Telangana", [
                                                                                     "A s rao nagar",
                                                                                     "Himayathnagar",
                                                                                     "Motinagar",
                                                                                     "Ameerpet",
                                                                                     "Tolichowki",
                                                                                     "Dilsukhnagar",
                                                                                     "Kukatpally",
                                                                                     "Akruthitownship",
                                                                                     "Habsiguda",
                                                                                     "Panjagutta",
                                                                                     "Vizag",
                                                                                     "Tirupathi",
                                                                                     "Kurnool",
                                                                                ])
                                                                           }
                                                                           style={{ transform: "scale(1.2)" }}
                                                                      />
                                                                      AP & Telangana
                                                                      <span className="region-badge" style={{
                                                                           backgroundColor: (selectedRegions["AP & Telangana"] || []).length === 13 ? "#28a745" : "#17a2b8",
                                                                           color: "white",
                                                                           padding: "4px 12px",
                                                                           borderRadius: "20px",
                                                                           fontSize: "0.75rem",
                                                                           fontWeight: "bold"
                                                                      }}>
                                                                           {(selectedRegions["AP & Telangana"] || []).length}/13
                                                                      </span>
                                                                 </label>
                                                            </div>
                                                            <div
                                                                 className="branch-list"
                                                                 style={{
                                                                      maxHeight: "200px",
                                                                      overflowY: "auto",
                                                                      padding: "8px",
                                                                      border: "1px solid #e9ecef",
                                                                      borderRadius: "6px",
                                                                      boxSizing: "border-box",
                                                                      backgroundColor: "#f8f9fa",
                                                                 }}
                                                            >
                                                                 {[
                                                                      "A s rao nagar",
                                                                      "Himayathnagar",
                                                                      "Motinagar",
                                                                      "Ameerpet",
                                                                      "Tolichowki",
                                                                      "Dilsukhnagar",
                                                                      "Kukatpally",
                                                                      "Akruthitownship",
                                                                      "Habsiguda",
                                                                      "Panjagutta",
                                                                      "Vizag",
                                                                      "Tirupathi",
                                                                      "Kurnool",
                                                                 ].map((branch) => (
                                                                      <label
                                                                           key={branch}
                                                                           className="branch-checkbox"
                                                                           style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                padding: "6px 8px",
                                                                                cursor: "pointer",
                                                                                fontSize: "0.875rem",
                                                                                borderRadius: "4px",
                                                                                marginBottom: "2px",
                                                                                transition: "background-color 0.2s"
                                                                           }}
                                                                           onMouseOver={(e) => e.target.style.backgroundColor = "#e9ecef"}
                                                                           onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}
                                                                      >
                                                                           <input
                                                                                type="checkbox"
                                                                                checked={(selectedRegions["AP & Telangana"] || []).includes(branch)}
                                                                                onChange={() => handleBranchToggle("AP & Telangana", branch)}
                                                                                style={{
                                                                                     marginRight: "8px",
                                                                                     transform: "scale(1.1)"
                                                                                }}
                                                                           />
                                                                           {branch}
                                                                      </label>
                                                                 ))}
                                                            </div>
                                                       </div>

                                                       {/* Kolkata */}
                                                       <div className="region-card" style={{
                                                            flex: "0 0 auto",
                                                            minWidth: "280px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            padding: "16px",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                       }}>
                                                            <div className="region-card-header" style={{
                                                                 marginBottom: "12px",
                                                                 paddingBottom: "12px",
                                                                 borderBottom: "2px solid #e9ecef"
                                                            }}>
                                                                 <label className="region-select-all" style={{
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      gap: "8px",
                                                                      cursor: "pointer",
                                                                      fontWeight: "bold",
                                                                      fontSize: "1rem"
                                                                 }}>
                                                                      <input
                                                                           type="checkbox"
                                                                           checked={(selectedRegions["Kolkata"] || []).length === 4}
                                                                           onChange={() =>
                                                                                handleSelectAll("Kolkata", [
                                                                                     "VIP Road",
                                                                                     "Barasat",
                                                                                     "Kasba",
                                                                                     "Krishna Nagar",
                                                                                ])
                                                                           }
                                                                           style={{ transform: "scale(1.2)" }}
                                                                      />
                                                                      Kolkata
                                                                      <span className="region-badge" style={{
                                                                           backgroundColor: (selectedRegions["Kolkata"] || []).length === 4 ? "#28a745" : "#17a2b8",
                                                                           color: "white",
                                                                           padding: "4px 12px",
                                                                           borderRadius: "20px",
                                                                           fontSize: "0.75rem",
                                                                           fontWeight: "bold"
                                                                      }}>
                                                                           {(selectedRegions["Kolkata"] || []).length}/4
                                                                      </span>
                                                                 </label>
                                                            </div>
                                                            <div className="branch-list" style={{
                                                                 maxHeight: "200px",
                                                                 overflowY: "auto",
                                                                 padding: "8px",
                                                                 border: "1px solid #e9ecef",
                                                                 borderRadius: "6px",
                                                                 boxSizing: "border-box",
                                                                 backgroundColor: "#f8f9fa",
                                                            }}>
                                                                 {["VIP Road", "Barasat", "Kasba", "Krishna Nagar"].map((branch) => (
                                                                      <label key={branch} className="branch-checkbox" style={{
                                                                           display: "flex",
                                                                           alignItems: "center",
                                                                           padding: "6px 8px",
                                                                           cursor: "pointer",
                                                                           fontSize: "0.875rem",
                                                                           borderRadius: "4px",
                                                                           marginBottom: "2px",
                                                                           transition: "background-color 0.2s"
                                                                      }}
                                                                           onMouseOver={(e) => e.target.style.backgroundColor = "#e9ecef"}
                                                                           onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}>
                                                                           <input
                                                                                type="checkbox"
                                                                                checked={(selectedRegions["Kolkata"] || []).includes(branch)}
                                                                                onChange={() => handleBranchToggle("Kolkata", branch)}
                                                                                style={{
                                                                                     marginRight: "8px",
                                                                                     transform: "scale(1.1)"
                                                                                }}
                                                                           />
                                                                           {branch}
                                                                      </label>
                                                                 ))}
                                                            </div>
                                                       </div>

                                                       {/* Pune */}
                                                       <div className="region-card" style={{
                                                            flex: "0 0 auto",
                                                            minWidth: "280px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            padding: "16px",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                       }}>
                                                            <div className="region-card-header" style={{
                                                                 marginBottom: "12px",
                                                                 paddingBottom: "12px",
                                                                 borderBottom: "2px solid #e9ecef"
                                                            }}>
                                                                 <label className="region-select-all" style={{
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      gap: "8px",
                                                                      cursor: "pointer",
                                                                      fontWeight: "bold",
                                                                      fontSize: "1rem"
                                                                 }}>
                                                                      <input
                                                                           type="checkbox"
                                                                           checked={(selectedRegions["Pune"] || []).length === 4}
                                                                           onChange={() =>
                                                                                handleSelectAll("Pune", [
                                                                                     "Satara",
                                                                                     "Hadapsar",
                                                                                     "Mayur Colony",
                                                                                     "Kalyani Nagar",
                                                                                ])
                                                                           }
                                                                           style={{ transform: "scale(1.2)" }}
                                                                      />
                                                                      Pune
                                                                      <span className="region-badge" style={{
                                                                           backgroundColor: (selectedRegions["Pune"] || []).length === 4 ? "#28a745" : "#17a2b8",
                                                                           color: "white",
                                                                           padding: "4px 12px",
                                                                           borderRadius: "20px",
                                                                           fontSize: "0.75rem",
                                                                           fontWeight: "bold"
                                                                      }}>
                                                                           {(selectedRegions["Pune"] || []).length}/4
                                                                      </span>
                                                                 </label>
                                                            </div>
                                                            <div className="branch-list" style={{
                                                                 maxHeight: "200px",
                                                                 overflowY: "auto",
                                                                 padding: "8px",
                                                                 border: "1px solid #e9ecef",
                                                                 borderRadius: "6px",
                                                                 boxSizing: "border-box",
                                                                 backgroundColor: "#f8f9fa",
                                                            }}>
                                                                 {["Satara", "Hadapsar", "Mayur Colony", "Kalyani Nagar"].map((branch) => (
                                                                      <label key={branch} className="branch-checkbox" style={{
                                                                           display: "flex",
                                                                           alignItems: "center",
                                                                           padding: "6px 8px",
                                                                           cursor: "pointer",
                                                                           fontSize: "0.875rem",
                                                                           borderRadius: "4px",
                                                                           marginBottom: "2px",
                                                                           transition: "background-color 0.2s"
                                                                      }}
                                                                           onMouseOver={(e) => e.target.style.backgroundColor = "#e9ecef"}
                                                                           onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}>
                                                                           <input
                                                                                type="checkbox"
                                                                                checked={(selectedRegions["Pune"] || []).includes(branch)}
                                                                                onChange={() => handleBranchToggle("Pune", branch)}
                                                                                style={{
                                                                                     marginRight: "8px",
                                                                                     transform: "scale(1.1)"
                                                                                }}
                                                                           />
                                                                           {branch}
                                                                      </label>
                                                                 ))}
                                                            </div>
                                                       </div>

                                                       {/* Bangalore */}
                                                       <div className="region-card" style={{
                                                            flex: "0 0 auto",
                                                            minWidth: "280px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            padding: "16px",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                       }}>
                                                            <div className="region-card-header" style={{
                                                                 marginBottom: "12px",
                                                                 paddingBottom: "12px",
                                                                 borderBottom: "2px solid #e9ecef"
                                                            }}>
                                                                 <label className="region-select-all" style={{
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      gap: "8px",
                                                                      cursor: "pointer",
                                                                      fontWeight: "bold",
                                                                      fontSize: "1rem"
                                                                 }}>
                                                                      <input
                                                                           type="checkbox"
                                                                           checked={(selectedRegions["Bangalore"] || []).length === 2}
                                                                           onChange={() =>
                                                                                handleSelectAll("Bangalore", ["HSR Layout", "Yelahanka"])
                                                                           }
                                                                           style={{ transform: "scale(1.2)" }}
                                                                      />
                                                                      Bangalore
                                                                      <span className="region-badge" style={{
                                                                           backgroundColor: (selectedRegions["Bangalore"] || []).length === 2 ? "#28a745" : "#17a2b8",
                                                                           color: "white",
                                                                           padding: "4px 12px",
                                                                           borderRadius: "20px",
                                                                           fontSize: "0.75rem",
                                                                           fontWeight: "bold"
                                                                      }}>
                                                                           {(selectedRegions["Bangalore"] || []).length}/2
                                                                      </span>
                                                                 </label>
                                                            </div>
                                                            <div className="branch-list" style={{
                                                                 maxHeight: "200px",
                                                                 overflowY: "auto",
                                                                 padding: "8px",
                                                                 border: "1px solid #e9ecef",
                                                                 borderRadius: "6px",
                                                                 boxSizing: "border-box",
                                                                 backgroundColor: "#f8f9fa",
                                                            }}>
                                                                 {["HSR Layout", "Yelahanka"].map((branch) => (
                                                                      <label key={branch} className="branch-checkbox" style={{
                                                                           display: "flex",
                                                                           alignItems: "center",
                                                                           padding: "6px 8px",
                                                                           cursor: "pointer",
                                                                           fontSize: "0.875rem",
                                                                           borderRadius: "4px",
                                                                           marginBottom: "2px",
                                                                           transition: "background-color 0.2s"
                                                                      }}
                                                                           onMouseOver={(e) => e.target.style.backgroundColor = "#e9ecef"}
                                                                           onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}>
                                                                           <input
                                                                                type="checkbox"
                                                                                checked={(selectedRegions["Bangalore"] || []).includes(branch)}
                                                                                onChange={() => handleBranchToggle("Bangalore", branch)}
                                                                                style={{
                                                                                     marginRight: "8px",
                                                                                     transform: "scale(1.1)"
                                                                                }}
                                                                           />
                                                                           {branch}
                                                                      </label>
                                                                 ))}
                                                            </div>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <br />
                         <div className="form-section" style={cardStyle}>
                              <div className="section-title" style={{ marginBottom: "5px" }}>
                                   Personality Assessment
                              </div>

                              <div style={grid6Columns}>
                                   <label>
                                        Attitude | Commitment to offered
                                        <select
                                             className="form-control input-form"

                                             name="attitude"
                                             value={personality.attitude}
                                             onChange={handlePersonalityChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             {personalityOptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                       {opt}
                                                  </option>
                                             ))}
                                        </select>
                                        {errors["personality.attitude"] && (
                                             <div className="field-error">{errors["personality.attitude"]}</div>
                                        )}
                                   </label>

                                   {/* <label>
                Relevant Job Knowledge
                <select
                  className="form-control input-form"
                  
                  name="jobKnowledge"
                  value={personality.jobKnowledge}
                  onChange={handlePersonalityChange}
                  style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                >
                  <option value="">-- Select --</option>
                  {personalityOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
                {errors["personality.jobKnowledge"] && (
                  <div className="field-error">{errors["personality.jobKnowledge"]}</div>
                )}
              </label> */}

                                   <label>
                                        Communication Skills
                                        <select
                                             className="form-control input-form"

                                             name="communication"
                                             value={personality.communication}
                                             onChange={handlePersonalityChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             {personalityOptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                       {opt}
                                                  </option>
                                             ))}
                                        </select>
                                        {errors["personality.communication"] && (
                                             <div className="field-error">{errors["personality.communication"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Confidence
                                        <select
                                             className="form-control input-form"

                                             name="confidence"
                                             value={personality.confidence}
                                             onChange={handlePersonalityChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             {personalityOptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                       {opt}
                                                  </option>
                                             ))}
                                        </select>
                                        {errors["personality.confidence"] && (
                                             <div className="field-error">{errors["personality.confidence"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Personality
                                        <select
                                             className="form-control input-form"

                                             name="personality"
                                             value={personality.personality}
                                             onChange={handlePersonalityChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             {personalityOptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                       {opt}
                                                  </option>
                                             ))}
                                        </select>
                                        {errors["personality.personality"] && (
                                             <div className="field-error">{errors["personality.personality"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Flexibility to work at different
                                        <select
                                             className="form-control input-form"

                                             name="flexibility"
                                             value={personality.flexibility}
                                             onChange={handlePersonalityChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             {personalityOptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                       {opt}
                                                  </option>
                                             ))}
                                        </select>
                                        {errors["personality.flexibility"] && (
                                             <div className="field-error">{errors["personality.flexibility"]}</div>
                                        )}
                                   </label>
                              </div>
                         </div>



                    </div>
               </div>

               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0px" }}>
                    <div className="small-muted">All fields are mandatory.</div>
                    <div className="form-actions">
                         <button
                              type="button"
                              className="btn"
                              style={{ background: "#9CA3AF" }}
                              onClick={onCancel}
                              disabled={isSubmitting}
                         >
                              Cancel
                         </button>

                         {/* <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="btn btn-warning pull-right"
                                                onClick={(e) => handleSubmit(e, 'draft')}
                                            >
                                                {isSubmitting ? 'Submitting...' : 'Save as Drafts'}
                                            </button> */}
                         <button
                              type="submit"
                              className="btn btn-warning pull-right"
                              disabled={isSubmitting}
                         >
                              {isSubmitting ? "Saving..." : "Save Assessment"}
                         </button>
                    </div>
               </div>
          </form>
     );
}